import React from "react";
import { ReleaseDropdown } from "./ReleaseDropdown";

export function ReleaseSelect({ task, onTaskChange, className }) {
  return (
    <ReleaseDropdown
      task={task}
      onTaskChange={onTaskChange}
      className={className}
      variant="default"
      showLabel={true}
    />
  );
}